// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Belt_List from "../../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as CrmControlledRelease from "../entity/CrmControlledRelease.bs.js";
import * as CrmControlledReleaseApiModel from "../api-model/CrmControlledReleaseApiModel.bs.js";

function decodeBetaUser(data) {
  return {
          admin: {
            id: data.admin.id,
            name: data.admin.name,
            email: data.admin.email
          },
          page_config: Belt_List.toArray(List.map((function (page) {
                      return {
                              view_name: page.page_name,
                              version_access: CrmControlledRelease.fromString(page.version_access)
                            };
                    }), data.page_config))
        };
}

function execute(json) {
  return decodeBetaUser(DeccoUtils$Catalyst.resolveResult(CrmControlledReleaseApiModel.t_decode(json), "CrmControlledReleaseEntityMapper.res"));
}

export {
  decodeBetaUser ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
